export const ENV_APP_NAME = '/appactivation';
export const APIM_SUBSCRIPTION_KEY = 'f63ddcb20ce74a85ab907564edc8de40';
export const PORT = process.env.REACT_APP_DEV_PORT;

export const API_TIME_OUT = 35000;

export const HOST = {
	BASE_APIM_URL: 'https://api-quarterly.paycor.com',
	BASE_HCM_URL: 'https://HCM-quarterly.paycor.com',
	BASE_SECURE_URL: 'https://secure-quarterly.paycor.com',
	BASE_DEVELOPER_PORTAL_URL: 'https://developers-quarterly.paycor.com',
	PUBLIC_API_URL_BASE: 'https://apis-quarterly.paycor.com',
	UI_URL_BASE: `https://local.paycor.com:${PORT}${ENV_APP_NAME}`,
	environment: 'local',
	APIM_SUBSCRIPTION_KEY: 'f63ddcb20ce74a85ab907564edc8de40',
	AUTHENTICATION_URL: 'https://hcm-quarterly.paycor.com/',
	SESSION_TIMEOUT_LOCAL_MODE: true,
	CODE_VERIFIER: 'CA1d7NlwyPsKNbx~SCnBy-yqx98vJsh8AHA_NNsP.fHTJGlgtrKWVcvBGmVyaJ6HVhWOTQkTmX7v~RxHipdY.PdB3fntH3kfWFnESobpPsXQ23Z.6_.gl7IP_zVyIN-n'
};

export const securitySettings = {
	client_id: 'AppActivationUIAppId',
	redirect_uri: `${HOST.UI_URL_BASE}/oauth/silent_renew.html`,
	response_type: 'token',
	scope: 'appactivationUi',
	authority: '/sts/v1/common',
	silent_redirect_uri: `${HOST.UI_URL_BASE}/oauth/silent_renew.html`,
	automaticSilentRenew: true,
	filterProtocolClaims: true,
	loadUserInfo: true,
	includeIdTokenInSilentRenew: false,
	extraQueryParams: { 'subscription-key': APIM_SUBSCRIPTION_KEY }
};
